import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47b0020c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808ERenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请在答题区三角形选出与前图例区三角形的颜色完全相同的答案（包含旋转后相同）。", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_E808ETriangle = _resolveComponent("E808ETriangle");
  const _component_el_button = _resolveComponent("el-button");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "点击“展示图例”按钮，左侧图例区三角形完整显示 " + _toDisplayString($props.difficulty.flashInterval) + " 秒，请记住该三角形中三条内径的颜色，", 1), _createElementVNode("span", null, _toDisplayString($props.difficulty.flashInterval) + " 秒后左侧图例区三角形内径变为黑色，答题区的三角形显示出来；", 1), _hoisted_4]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center mt48"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "flex items-center justify-center flex flex-col",
      style: {
        "height": "300px"
      }
    }, {
      default: _withCtx(() => [$data.example == 1 ? (_openBlock(), _createBlock(_component_E808ETriangle, {
        key: 0,
        colors: $props.data.question
      }, null, 8, ["colors"])) : _createCommentVNode("", true), $data.example == 2 ? (_openBlock(), _createBlock(_component_E808ETriangle, {
        key: 1,
        colors: $props.data.question.slice(0, 3) + 'XXX'
      }, null, 8, ["colors"])) : _createCommentVNode("", true), $data.example == 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        style: {
          "width": "100px"
        },
        onClick: $options.showExample
      }, {
        default: _withCtx(() => [_createTextVNode("展示图例")]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$data.example > 1 ? (_openBlock(), _createBlock(_component_AnswerButtonGroup, {
        onChoose: $options.onChoosed,
        "option-width": "140px",
        key: `e808e${$props.data.questionIndex}}`,
        review: $props.review,
        reviewMode: $props.reviewMode,
        options: $data.letters.slice(0, $props.data.answers.length),
        single: false,
        ref: "answerBtns"
      }, {
        default: _withCtx(idx => [_createVNode(_component_E808ETriangle, {
          colors: $props.data.answers[idx.index]
        }, null, 8, ["colors"])]),
        _: 1
      }, 8, ["onChoose", "review", "reviewMode", "options"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })]);
}